const systemEntitiesList = [
  'business',
  'business-manager',
  'courier',
  'order',
  'client',
  'admin'
];
export default systemEntitiesList;
 